import { useQuery } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const documentQaFiltersQueryDocument = graphql(`
  query DocumentQaPage_Filters($brandAccountId: ID!) {
    brandAccount(brandAccountId: $brandAccountId) {
      surveys {
        id
        title
        brandGroups {
          id
          name
          brands {
            id
            name
          }
        }
      }
    }
  }
`)

type Brand = {
  id: number
  name: string
}

type BrandGroup = {
  brands: Brand[]
  id: number
  name: string
}

type Survey = {
  brandGroups: BrandGroup[]
  id: string
  title: string
}

export const useDocumentQaFilters = (brandAccountId: string) => {
  const graphQLRequest = useGraphQLRequest()

  const query = useQuery({
    queryFn: async () => {
      const result = await graphQLRequest({
        document: documentQaFiltersQueryDocument,
        variables: { brandAccountId },
      })
      const surveys = result.brandAccount?.surveys ?? []

      return {
        surveys: surveys
          .filter((s): s is NonNullable<typeof s> => s != null)
          .map((s): Survey => ({
            brandGroups: (s.brandGroups ?? [])
              .filter((bg): bg is NonNullable<typeof bg> => bg != null)
              .map((bg) => ({
                brands: (bg.brands ?? [])
                  .filter((b): b is NonNullable<typeof b> => b != null)
                  .map((b) => ({ id: b.id, name: b.name })),
                id: bg.id,
                name: bg.name,
              })),
            id: s.id,
            title: s.title,
          })),
      }
    },
    queryKey: ['documentQaFilters', brandAccountId],
  })

  return {
    isPending: query.isPending,
    surveys: query.data?.surveys ?? [],
  }
}
